/*
 *
 * SetPassword actions
 *
 */

import {
  VALIDATE_USER_WATCHER,
  VALIDATE_USER_SUCCESS,
  VALIDATE_USER_FAILED,
  SET_PASSWORD_WATCHER,
  SET_PASSWORD_SUCCESS,
  SET_PASSWORD_FAILED,
} from "./constants"

export function setPasswordWatcher(payload) {
  return {
    type: SET_PASSWORD_WATCHER,
    payload,
  }
}

export function setPasswordSuccess(payload) {
  return {
    type: SET_PASSWORD_SUCCESS,
    payload,
  }
}

export function setPasswordFailed(payload) {
  return {
    type: SET_PASSWORD_FAILED,
    payload,
  }
}

export function validateUserWatcher(payload) {
  return {
    type: VALIDATE_USER_WATCHER,
    payload,
  }
}

export function validateUserSuccess(payload) {
  return {
    type: VALIDATE_USER_SUCCESS,
    payload,
  }
}

export function validateUserFailed(payload) {
  return {
    type: VALIDATE_USER_FAILED,
    payload,
  }
}
